import { ReactNode, MouseEvent, memo, useState, useEffect } from 'react';
import GridComponent from '../../../../../../component/grid/GridComponent.component';
import { Grid } from '@material-ui/core';
import Modal from '../../../../../../component/modal/Modal.component';
import { Span } from '../../../../../../component/modal/ModalStyle';
import Button from '../../../../../../component/buttton/Button.component';


interface Props {
    children?: ReactNode;
    open: boolean;
    onClickSubmit(): void;
    title: string;
    handleClick(event: MouseEvent<HTMLElement>): void
}


function ModalUpdate({ open, title, onClickSubmit, handleClick}: Props) {

            return (
                <Modal open={open} handleClick={() => {}} >
                <Span style={{textAlign:"center"}}>{title.toLocaleUpperCase()}</Span>
                <GridComponent margin="10px auto 10px auto" spacing={2}>
                    <Grid item margin="0 auto" xs={6}>
                        <Button title='Sim' size='small' onClick={()=> onClickSubmit()} fullWidth />
                    </Grid>
                    <Grid item margin="0 auto" xs={6}>
                        <Button title='Não' size='small' onClick={handleClick} fullWidth />
                    </Grid>
                </GridComponent>
            </Modal>
            );
}

export default memo(ModalUpdate);